import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Radium, { StyleRoot } from 'radium';

import Inquiries from './pages/Inquiries';
import NotFoundError from './pages/NotFoundError';
import Invite from './pages/Referrals/Invite';
import Dashboard from './pages/Referrals/Dashboard';
import DownloadApp from './pages/DownloadApp';
import Careers from './pages/Careers';
import AboutUs from './pages/AboutUs';
//eslint-disable-next-line
import FontAwesome from '@bit/fabfitfun.shared.global.font-awesome-collection';
import './App.css';
import { loadTalkable } from './utils/loadTalkable';
import { getUserInfo } from './services';

function App() {
  useEffect(() => {
    getUserInfo().then((responseJson) => {
      loadTalkable(responseJson);
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      loadTalkable();
    });
  }, []);

  return (
    <StyleRoot>
      <div className="App">
        <Router>
          <Switch>
            <Route path="/inquiries" component={Inquiries} />
            <Route path="/s/inquiries" component={Inquiries} />
            <Route path="/invite" component={Invite} />
            <Route path="/s/invite" component={Invite} />
            <Route path="/my-account/referral-dashboard" component={Dashboard} />
            <Route path="/about-us" component={AboutUs} />
            <Route path="/s/about-us" component={AboutUs} />
            <Route path="/careers" component={Careers} />
            <Route path="/mobile-app" component={DownloadApp} />
            <Route path="/s/mobile-app" component={DownloadApp} />
            <Route component={NotFoundError} />
          </Switch>
        </Router>
      </div>
    </StyleRoot>
  );
}

export default Radium(App);
